<template>
    <div>
        <ChartView />
    </div>
</template>

<script>
import ChartView from '../../components/FinancialAnalysis/ChartView.vue';

export default {
    components: {
        ChartView
    }
}
</script>
